module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k6WnI"))).then(() => parcelRequire('3NNNW'));